import React from "react";

export default () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 23C11.4696 23 10.9609 22.7893 10.5858 22.4142C10.2107 22.0391 10 21.5304 10 21H9C9 21.7956 9.31607 22.5587 9.87868 23.1213C10.4413 23.6839 11.2044 24 12 24C12.7956 24 13.5587 23.6839 14.1213 23.1213C14.6839 22.5587 15 21.7956 15 21H14C14 21.5304 13.7893 22.0391 13.4142 22.4142C13.0391 22.7893 12.5304 23 12 23Z"
      fill="currentColor"
    />
    <path
      d="M21.14 16C20.8394 16 20.5509 15.8813 20.3374 15.6696C20.1239 15.458 20.0026 15.1706 20 14.87V10.59C20.0693 8.47478 19.3338 6.41198 17.9419 4.81776C16.55 3.22355 14.6052 2.21658 12.5 2V0H11.5V2C9.39382 2.21429 7.44767 3.22061 6.05529 4.81534C4.66292 6.41008 3.92827 8.47417 4 10.59V14.87C3.99736 15.1706 3.87609 15.458 3.66258 15.6696C3.44908 15.8813 3.16062 16 2.86 16C2.63272 16.0026 2.41548 16.094 2.25476 16.2548C2.09404 16.4155 2.00259 16.6327 2 16.86V19.07C1.99731 19.3096 2.08926 19.5407 2.2559 19.7129C2.42253 19.8852 2.65039 19.9847 2.89 19.99H21.11C21.3496 19.9847 21.5775 19.8852 21.7441 19.7129C21.9107 19.5407 22.0027 19.3096 22 19.07V16.87C22 16.641 21.9097 16.4212 21.7487 16.2583C21.5877 16.0955 21.369 16.0026 21.14 16ZM21 19H3V17C3.54295 16.9644 4.05196 16.7233 4.42349 16.3258C4.79502 15.9283 5.00116 15.4041 5 14.86V10.59C5 6.4 8.14 3 12 3C15.86 3 19 6.4 19 10.59V14.87C19.0014 15.4124 19.2086 15.934 19.5799 16.3294C19.9512 16.7248 20.4588 16.9645 21 17V19Z"
      fill="currentColor"
    />
  </svg>
);
